import { useState } from "react";
import { IconButton, Tooltip } from "@material-ui/core";
import DownloadIcon from "@mui/icons-material/Download";
import RequestPageOutlined from "@mui/icons-material/RequestPageOutlined";
import downloadBoleto from "lib/api/download-boleto";
import {
  getBoletoNumeroTitulo,
  isBoletoDownloadAvailable,
} from "utils/boleto-download";

export default function BoletoDownloadIconButton({
  row,
  origem,
  icon = "download",
  onUnavailable,
  onError,
  className,
}) {
  const [isDownloading, setIsDownloading] = useState(false);
  const canDownload = isBoletoDownloadAvailable(row);
  const numeroTitulo = getBoletoNumeroTitulo(row);
  const isDocumentIcon = icon === "document";
  const availableTitle = isDocumentIcon ? "Visualizar Boleto" : "Baixar boleto";

  const handleClick = async (event) => {
    event.stopPropagation();
    event.preventDefault();

    if (!canDownload || isDownloading) {
      if (!canDownload && onUnavailable) {
        onUnavailable();
      }
      return;
    }

    setIsDownloading(true);

    try {
      await downloadBoleto(origem, numeroTitulo);
    } catch (error) {
      console.log(error);

      if (onError) {
        onError(error);
      }
    } finally {
      setIsDownloading(false);
    }
  };

  const tooltipTitle = isDownloading
    ? "Baixando boleto..."
    : canDownload
      ? availableTitle
      : "Boleto não disponível";

  return (
    <Tooltip title={tooltipTitle}>
      <IconButton
        type="button"
        size="small"
        color="primary"
        className={className}
        onClick={handleClick}
        onMouseDown={(event) => event.stopPropagation()}
        disabled={isDownloading}
        style={{ cursor: canDownload && !isDownloading ? "pointer" : "not-allowed" }}
        aria-label={tooltipTitle}
      >
        {isDocumentIcon ? (
          <RequestPageOutlined
            fontSize="small"
            color={canDownload && !isDownloading ? "primary" : "disabled"}
          />
        ) : (
          <DownloadIcon
            fontSize="small"
            color={canDownload && !isDownloading ? "primary" : "disabled"}
          />
        )}
      </IconButton>
    </Tooltip>
  );
}
